// extracted by mini-css-extract-plugin
export default {"organization-selector":"select-organization_organization-selector__xbHez"};